<template>
  <div
    class="aside-container"
    :class="{
      show
    }"
    @click="$emit('switch')"
  >
    <div class="aside-profile">
      <router-link
        :to="{
          name: 'home'
        }"
      >
        <img :src="system.logo" :alt="system.title" />
      </router-link>
      <span class="aside-profile-title">{{ system.title }}</span>
      <span class="aside-profile-description">{{ system.description }}</span>
    </div>
    <ul class="aside-buttons">
      <li>
        <router-link :to="{ name: 'home' }">
          <i class="iconfont iconshouye"></i>
          <span>首页</span>
        </router-link>
      </li>
      <li v-for="item in types" :key="item.id">
        <router-link :to="{ name: 'type', params: { id: item.id } }">
          <i class="iconfont" :class="item.iconClass"></i>
          <span>{{ item.name }} ({{ item.articleNumber }})</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getTypes } from "@/services/typeService";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      types: []
    };
  },
  async created() {
    const resp = await getTypes();
    this.types = resp.data;
  },
  computed: mapState("system", ["system"]),
  methods: {
    handleHref(name, params = {}) {
      if (this.$route.name !== name || this.$route.params.id !== params.id) {
        this.$router.push({ name, params });
        this.$emit("switch", false);
      }
    }
  }
};
</script>
